import Login from '@components/login/login.component';
import FullScreenCard from '@components/common/fullscreencard/FullScreenCard';
import { login } from '@services/user/user.actions';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import VarannanVeckaLogo from '@components/svg/varannanvecka';
import {
  DEFAULT_AUTHENTICATED_PATH,
  GMAIL_CONNECT_RETURN_PATH,
  getSafeReturnPath,
} from '@router/safeReturn';
import { clearPendingGmailAttempt } from '../../integrations/gmail/gmailAttemptVault';

interface IProps extends RouteComponentProps {
  login: (values: any) => void;
  token?: string;
}

export class PLoginContainer extends React.Component<IProps> {

  public componentDidMount() {
    if (this.props.token && this.props.token.length > 0) {
      this.props.history.replace(
        getSafeReturnPath(this.props.location.state) || DEFAULT_AUTHENTICATED_PATH
      );
      return;
    }
  }

  public componentWillUnmount() {
    const isGmailLogin = getSafeReturnPath(this.props.location.state) === GMAIL_CONNECT_RETURN_PATH;
    if (isGmailLogin && this.props.history.location.pathname !== GMAIL_CONNECT_RETURN_PATH) {
      clearPendingGmailAttempt();
    }
  }

  public render() {

    return (
      <FullScreenCard sideElement={<VarannanVeckaLogo />}>
        <Login onSubmit={this.handleSubmit} />
      </FullScreenCard>
    );
  }

  private handleSubmit = (values: any, saveCredentials: boolean = true) => {
    this.props.login({
      data: values,
      meta: {
        saveCredentials,
        history: this.props.history
      }
    });
  }
}

const mapDispatchToProps = {
  login,
};

function mapStateToProps(state: any) {
  if (!state.user || !state.user.session || !state.user.session.data || !state.user.session.data.authorization) {
    return {
      token: undefined
    };
  }
  return {
    token: state.user.session.data.authorization
  };
}

const LoginContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(PLoginContainer));

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/containers/login/login.container.tsx